export interface ICalendarEventStyle {
  left: string;
  width: string;
  top: string;
  backgroundColor: string;
  color: string;
  marginLeft: string;
  marginRight: string;
}
